export const TOAST_REGION_ATTRIBUTE = 'data-toast-region'
export const TOAST_REGION_SELECTOR = `[${TOAST_REGION_ATTRIBUTE}]`
